import { Directive, HostListener, HostBinding, EventEmitter, Output } from '@angular/core';

@Directive({
  selector: '[appDragAndDrop]'
})

export class DragAndDropDirective {

  @HostBinding('style.background') private background = '#F7F9FC';

  @Output() fileDropped = new EventEmitter<FileList>();

  constructor() { }

  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#FFFFFF';
  }
  @HostListener('dragleave', ['$event']) onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#F7F9FC';
  }

  @HostListener('drop', ['$event']) onDrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();

    const dataTransfer: DataTransfer = evt.dataTransfer;

    if (dataTransfer.files.length > 0) {
      this.fileDropped.emit(dataTransfer.files);
    }

  }
}
